// pack.js (universal version)
const PADDING_LENGTH = 50;
const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

function generateRandomString(length) {
    let result = '';
    for (let i = 0; i < length; i++) {
        result += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
    }
    return result;
}

// Universal base64 encode
function safeBtoa(str) {
    try {
        // Try Buffer first (modern env)
        return Buffer.from(str, 'utf8').toString('base64');
    } catch {
        // Fallback to btoa (legacy browsers)
        return btoa(unescape(encodeURIComponent(str)));
    }
}

// Universal base64 decode
function safeAtob(str) {
    try {
        // Try Buffer first (modern env)
        return Buffer.from(str, 'base64').toString('utf8');
    } catch {
        // Fallback to atob (legacy browsers)
        return decodeURIComponent(escape(atob(str)));
    }
}

export function pack(data) {
    const contents = JSON.stringify(data);
    const base64 = safeBtoa(contents);
    const prefix = generateRandomString(PADDING_LENGTH);
    const suffix = generateRandomString(PADDING_LENGTH);
    return { _data: prefix + base64 + suffix };
}

export function unpack(packed) {
    if (!packed || !packed._data || packed._data.length <= PADDING_LENGTH * 2) {
        throw new Error('Invalid packed data');
    }
    
    const base64 = packed._data.substring(
        PADDING_LENGTH, 
        packed._data.length - PADDING_LENGTH
    );
    const json = safeAtob(base64);
    return JSON.parse(json);
}